module.exports = __webpack_public_path__ + "static/assurdly-091dbd87473d6458d61e2f2d06a996af.svg";